import { blobUrl } from '../variables';

export const DIANA_AVATAR = `${blobUrl}/ui/profile/dianas/default.webp`;
